import {atom} from "jotai";

export const createWorkLogStateAtom = atom(false);
export const createWorkLogDataAtom = atom({});